import React from 'react';
import { Truck, CalendarClock, MapPin, PackageX } from 'lucide-react';
import DisclaimerBox from '../components/DisclaimerBox';

export default function Shipping() {
  return (
    <div className="bg-alp-black min-h-screen">
      <div className="border-b border-alp-line">
        <div className="max-w-4xl mx-auto px-5 md:px-8 py-16 text-center">
          <p className="text-alp-gold text-xs tracking-[0.3em] uppercase mb-3">Logistics</p>
          <h1 className="font-serif text-5xl md:text-6xl text-alp-cream heading-glow">Shipping Info</h1>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-5 md:px-8 py-16 space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Card icon={Truck} title="Shipping Rates">
            <ul className="space-y-2 text-alp-gray">
              <li>All orders sent via <span className="text-alp-cream">Australia Post Express Post</span></li>
              <li>Flat <span className="text-alp-cream">$13 AUD</span> Express Post</li>
              <li>Free Express Post on in-stock orders over <span className="text-alp-gold">$300 AUD</span></li>
            </ul>
          </Card>
          <Card icon={MapPin} title="Delivery Area">
            <p className="text-alp-gray">We ship to <span className="text-alp-cream">Australia only</span> &mdash; all states and territories. International shipping is not available and international addresses are blocked at checkout.</p>
          </Card>
          <Card icon={CalendarClock} title="Dispatch Times">
            <p className="text-alp-gray">All items are held <span className="text-alp-cream">in stock</span> and typically dispatch within <span className="text-alp-gold">1&ndash;2 business days</span> of payment confirmation.</p>
          </Card>
          <Card icon={PackageX} title="Stock Availability">
            <p className="text-alp-gray">We hold our full range in stock. If an item ever sells out it will simply show as <span className="text-alp-cream">out of stock</span> on the shop until the next batch lands &mdash; no waiting on supplier cycles.</p>
          </Card>
        </div>
        <DisclaimerBox />
      </div>
    </div>
  );
}

function Card({ icon: Icon, title, children }) {
  return (
    <div className="border border-alp-line rounded p-7 bg-alp-card/40">
      <Icon size={26} strokeWidth={1.4} className="text-alp-gold mb-4" />
      <h3 className="font-serif text-2xl text-alp-cream mb-3">{title}</h3>
      {children}
    </div>
  );
}
